import React from 'react'
import * as Comp from './popover.styles.ts'
import type { TPopoverProps } from './types/index.ts'
import { PopoverContent } from './components/popover-content/index.tsx'
import { PopoverTrigger } from './components/popover-trigger/index.tsx'
import { usePopoverLayout } from './hooks/usePopoverLayout.ts'
import {
  PositionAlignment,
  PositionDirection,
} from '~/utils/layout/position-enums'

const PopoverRoot = ({
  isOpen,
  title,
  description,
  onClose,
  tag,
  side = PositionDirection.TOP,
  align = PositionAlignment.MIDDLE,
  autoPosition = true,
  buttonText,
  onButtonPress,
  children,
  ...rest
}: TPopoverProps) => {
  const { rootLayout, isLayoutReady, rootRef, handleLayout } = usePopoverLayout(
    {
      isOpen,
    }
  )

  const renderChildren = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return null

    if (child.type === PopoverContent) {
      return React.cloneElement(child, {
        ...child.props,
        isOpen,
        title,
        description,
        onClose,
        tag,
        rootLayout,
        rootLayoutReady: isLayoutReady,
        side,
        align,
        autoPosition,
        buttonText,
        onButtonPress,
      })
    }

    return child
  })

  return (
    <Comp.Root ref={rootRef} {...rest} onLayout={handleLayout}>
      {renderChildren}
    </Comp.Root>
  )
}

export const Popover = {
  Root: PopoverRoot,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
}

export type { TPopoverProps } from './types'
